export enum TreeState {
    init = '',
    create = 'C', 
    update = 'U', 
    delete = 'D'
  }